export default __webpack_public_path__ + "static/media/information-red.0895179f.svg";